import React, { useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

function Branch({
  setBranchName,
  branchName,
  regionName,
  letMore,
  office1,
  office2,
  office3,
  office4,
  office5,
  office6,
  office7,
  office8,
}) {
  const [show, setShow] = useState(letMore === 8 ? false : true);
  const startAcardion = () => {
    setShow(!show);
  };
  const handleClick = (evt) => {
    setBranchName(evt.target.textContent);
  };
  return (
    <ul className="font-semibold w-full xl:w-[28%] text-white">
      <li className={`border-b-2 ${show ? "" : "pb-2"} cursor-pointer border-white sm:w-[320px]`}>
        <div
          onClick={startAcardion}
          className="flex text-[22px] sm:text-[28px] items-center py-1 px-2 justify-between"
        >
          <strong>{regionName}</strong>
          <button className={`${show ? "rotate-2" : ""} duration-200 -rotate-90`}>
            <KeyboardArrowDownIcon />
          </button>
        </div>
        <div
          className={`px-5 flex duration-300 flex-col space-y-1.5 sm:space-y-2.5 ${show
            ? "h-0 overflow-hidden"
            : `${letMore === 1 ? "h-[25px] sm:h-[38px]" : ""}${letMore === 2 ? "h-[55px] sm:h-[78px]" : ""}${letMore === 8 ? "h-[235px] sm:h-[318px]" : ""}  overflow-hidden`
            }`}
        >
          {letMore === 1 &&
            <strong
              onClick={handleClick}
              className={`text-[16px] sm:text-[20px] mt-0.5 sm:mt-2 font-normal ${branchName === office1 ? "text-[#00C9DB]" : ""
                }`}
            >
              {office1}
            </strong>
          }
          {letMore === 2 &&
            <>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px] mt-0.5 sm:mt-2 font-normal ${branchName === office1 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office1}
              </strong>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px]  font-normal ${branchName === office2 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office2}
              </strong>
            </>
          }
          {letMore === 3 &&
            <>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px] mt-0.5 sm:mt-2 font-normal ${branchName === office1 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office1}
              </strong>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px]  font-normal ${branchName === office2 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office2}
              </strong>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px]  font-normal ${branchName === office3 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office3}
              </strong>
            </>
          }
          {letMore === 4 &&
            <>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px] mt-0.5 sm:mt-2 font-normal ${branchName === office1 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office1}
              </strong>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px]  font-normal ${branchName === office2 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office2}
              </strong>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px]  font-normal ${branchName === office3 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office3}
              </strong>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px]  font-normal ${branchName === office4 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office4}
              </strong>
            </>
          }
          {letMore === 5 &&
            <>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px] mt-0.5 sm:mt-2 font-normal ${branchName === office1 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office1}
              </strong>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px]  font-normal ${branchName === office2 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office2}
              </strong>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px]  font-normal ${branchName === office3 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office3}
              </strong>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px]  font-normal ${branchName === office4 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office4}
              </strong>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px]  font-normal ${branchName === office5 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office5}
              </strong>
            </>
          }
          {letMore === 6 &&
            <>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px] mt-0.5 sm:mt-2 font-normal ${branchName === office1 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office1}
              </strong>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px]  font-normal ${branchName === office2 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office2}
              </strong>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px]  font-normal ${branchName === office3 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office3}
              </strong>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px]  font-normal ${branchName === office4 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office4}
              </strong>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px]  font-normal ${branchName === office5 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office5}
              </strong>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px]  font-normal ${branchName === office6 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office6}
              </strong>
            </>
          }
          {letMore === 7 &&
            <>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px] mt-0.5 sm:mt-2 font-normal ${branchName === office1 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office1}
              </strong>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px]  font-normal ${branchName === office2 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office2}
              </strong>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px]  font-normal ${branchName === office3 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office3}
              </strong>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px]  font-normal ${branchName === office4 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office4}
              </strong>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px]  font-normal ${branchName === office5 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office5}
              </strong>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px]  font-normal ${branchName === office6 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office6}
              </strong>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px]  font-normal ${branchName === office7 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office7}
              </strong>
            </>
          }
          {letMore === 8 && (
            <>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px] mt-0.5 sm:mt-2 font-normal ${branchName === office1 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office1}
              </strong>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px]  font-normal ${branchName === office2 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office2}
              </strong>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px]  font-normal ${branchName === office3 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office3}
              </strong>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px]  font-normal ${branchName === office4 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office4}
              </strong>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px]  font-normal ${branchName === office5 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office5}
              </strong>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px]  font-normal ${branchName === office6 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office6}
              </strong>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px]  font-normal ${branchName === office7 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office7}
              </strong>
              <strong
                onClick={handleClick}
                className={`text-[16px] sm:text-[20px]  font-normal ${branchName === office8 ? "text-[#00C9DB]" : ""
                  }`}
              >
                {office8}
              </strong>
            </>
          )}
        </div>
      </li >
    </ul >
  );
}

export default Branch;
